module.exports = __webpack_public_path__ + "img/DK36041021.9b99a6a9.png";